export const AttendanceHeader = [
  {
    name: "Date",
    field: "date",
  },
  {
    name: "In Time",
    field: "punch_in",
  },
  {
    name: "Out Time",
    field: "punch_out",
  },
  {
    name: "Working Hours",
    field: "working_hours",
  },
  {
    name: "Attendace",
    field: "attendace",
  },

  // {
  //   name: "Lat/Long",
  //   field: "location",
  // },
  {
    name: "Approved by",
    field: "approver",
  },
];

export const TeamTableData = [
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
];

export const AttendanceHeaderALL =[
  {
    name: "Date",
    field: "date",
  },
  {
    name: "In Time",
    field: "punch_in",
  },
  {
    name: "Out Time",
    field: "punch_out",
  },
  {
    name: "Working Hours",
    field: "working_hours",
  },
  {
    name: "Attendace",
    field: "work_type",
  },

  // {
  //   name: "Lat/Long",
  //   field: "location",
  // },
  {
    name: "Approved by",
    field: "approver",
  },
];

export const AttendanceAllData = [
  {
    id: 1,
    team_name: "Toushar Bhalla",
    in_time: "11:00 AM",
    out_time: "07:00 PM",
    working_hours: "12.0",
    overtime_hours: "0.1",
    type: "Present",
    location: "View",
    action: "",
  },

  {
    id: 2,
    team_name: "Toushar Bhalla",
    in_time: "11:00 AM",
    out_time: "07:00 PM",
    working_hours: "12.0",
    overtime_hours: "0.1",
    type: "Present",
    location: "View",
    action: "",
  },

  {
    id: 3,
    team_name: "Toushar Bhalla",
    in_time: "11:00 AM",
    out_time: "07:00 PM",
    working_hours: "12.0",
    overtime_hours: "0.1",
    type: "Half Day",
    location: "View",
    action: "",
  },
];
